import { PropsWithChildren } from 'react';
import Modal from '@/shared/crisp/Modal';
import PercentageIcon from '@/components/Icons/Percentage';
import Div from '../Div';
import Paragraph from '../Paragraph';
import Button from '../Button';
import { CouponItem } from '@/components/Product/AddToCart';
import { getFormattedPrice } from '@/utils/price';

export interface CouponProps {
  open: boolean;
  onClose: () => void;
  couponData?: CouponItem;
}
function CouponAppliedModal(props: PropsWithChildren<CouponProps>) {
  const { open, onClose, couponData } = props;
  return (
    <Modal
      id="coupons-list"
      open={open}
      showCloseButton={false}
      showHeader={false}
      onClose={onClose}
    >
      <Div className="px-s5 py-s6 flex flex-col gap-s3">
        <PercentageIcon />
        <Paragraph className="text-cm-primary text-h-3 mb-s3">
          {couponData?.coupon} applied
        </Paragraph>
        <Paragraph className="text-cm-primary text-h-2 mb-s4">
          You will get {getFormattedPrice(couponData?.applicableDisc)} off on this purchase
        </Paragraph>
        <Button theme="primary" onClick={onClose}>
          Okay
        </Button>
      </Div>
    </Modal>
  );
}

export default CouponAppliedModal;
